import { Button, Row } from "antd";
import "../../../../../../../../../components/DefaultFormButtons/style.scss";
import { TRecord } from "../types";
import { useCallback, useMemo } from "react";
import { usePermissions } from "../../../../../../../../../lib/hooks/usePermissions";

type TBtnsProps = {
  onSaveClick: (isNew: boolean, record: TRecord) => Promise<void>;
  onCancelClick: () => void;
  onDeleteClick: (id: string) => void;
  isFormDisabled: boolean;
  record: TRecord;
};

export const FormButtons = ({
  onSaveClick,
  onCancelClick,
  onDeleteClick,
  isFormDisabled,
  record,
}: TBtnsProps) => {
  const onDelete = useCallback(
    () => onDeleteClick(record.id || ""),
    [onDeleteClick, record]
  );

  const { hasAccessByController } = usePermissions("ContractDisbursements");

  const onSave = useCallback(
    (event: React.MouseEvent<HTMLElement, MouseEvent>) => {
      const id: string = event.currentTarget.id;
      onSaveClick(id === "addNew", record);
    },
    [onSaveClick, record]
  );

  const isCloseDisabled: boolean = useMemo(() => {
    if (hasAccessByController(record.id !== null ? "Modify" : "Add")) {
      return isFormDisabled;
    }

    return false;
  }, [hasAccessByController, isFormDisabled, record.id]);

  return (
    <Row className="default-form-buttons w-100 pa-6 divider d-flex justify-space-between position-absolute">
      <div className="d-flex default-form-buttons-main">
        {hasAccessByController(record.id !== null ? "Modify" : "Add") && (
          <Button
            id="add"
            shape="round"
            type="primary"
            disabled={isFormDisabled}
            loading={isFormDisabled}
            onClick={onSave}
          >
            {record.id !== null ? "Save" : "Add"}
          </Button>
        )}
        {record.id === null && hasAccessByController("Add") && (
          <Button
            id="addNew"
            shape="round"
            disabled={isFormDisabled}
            loading={isFormDisabled}
            onClick={onSave}
          >
            Add & New
          </Button>
        )}
        <Button
          shape="round"
          disabled={isCloseDisabled}
          onClick={onCancelClick}
        >
          Cancel
        </Button>
      </div>
      <div>
        {record.id !== null && hasAccessByController("Delete") && (
          <Button type="link" disabled={isFormDisabled} onClick={onDelete}>
            Delete
          </Button>
        )}
      </div>
    </Row>
  );
};
